import { Node, SettingField } from '@alilc/lowcode-shell';
var ShellModelFactory = /*#__PURE__*/function () {
  function ShellModelFactory() {}
  var _proto = ShellModelFactory.prototype;
  _proto.createNode = function createNode(node) {
    return Node.create(node);
  };
  _proto.createSettingField = function createSettingField(prop) {
    return SettingField.create(prop);
  };
  return ShellModelFactory;
}();
export var shellModelFactory = new ShellModelFactory();